import response from '../../../../utils/response'

export default {
  upload: {
    state: {},
    methods: {
      getToken: {
        timeout: 240,
        handle: function ({api, system}) {
          const $http = window.vueInstantiation.$http
          return response($http(api.type, api.url, { clientType: system }))
        }
      }
    }
  }
}
